// extracted by mini-css-extract-plugin
module.exports = {"fontSizeButton":"ExtendedFontSizeButton_fontSizeButton__1GIOx","button":"ExtendedFontSizeButton_button__23pjF","active":"ExtendedFontSizeButton_active__29JEA"};